/**
 * Root Reducer
 */
// Dependencies
import storage from 'redux-persist/lib/storage';
import { persistCombineReducers } from 'redux-persist';

// Reducers
import auth from 'store/reducers/auth';
import app from 'store/reducers/app';
import catalogs from 'store/reducers/catalogs';
import caja from 'store/reducers/caja';
import dashboard from 'store/reducers/dashboard';

const config = {
  key: 'root',
  storage,
  whitelist: [
    'auth',
    'app',
    'catalogs',
  ],
  blacklist: [
    'auth.entidad',
    'app.recibos',
    'catalogs.padrones',
    'catalogs.permisos',
    'caja',
  ],
};

export default () => persistCombineReducers(config, {
  auth,
  app,
  catalogs,
  caja,
  dashboard,
});
